export const playCaptchaAudio = async (text: string): Promise<void> => {
  if (!window.speechSynthesis) {
    return;
  }

  const button = document.getElementById("speaker-button") as HTMLButtonElement | null;
  if (!button) return;

  if (speechSynthesis.speaking) {
    button.innerHTML = "►";
    speechSynthesis.cancel();
    return;
  }
  if (text.length !== 0) {
    button.innerHTML = "𝝞𝝞";
  }

  for (let i = 0; i < text.length; i++) {
    const word = text[i];
    const utterance = new SpeechSynthesisUtterance(word);
    utterance.lang = "en-US";
    utterance.pitch = 1;
    utterance.rate = 1;

    if (i === text.length - 1) {
      utterance.onend = () => {
        button.innerHTML = "►";
      };
    }

    speechSynthesis.speak(utterance);
  }

};
